import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { firstValueFrom } from 'rxjs';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { VendorGridItemDto, VendorPagedRequestDto, VendorService } from 'src/app/proxy/vendors';
import { AppConsts } from '../../AppConsts';

@Component({
  selector: 'app-vendor-autocomplete',
  standalone: false,
  templateUrl: './vendor-autocomplete.component.html',
})
export class VendorAutocompleteComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;

  @Output() changeSelectedVendor = new EventEmitter<VendorGridItemDto>();
  vendors: VendorGridItemDto[];
  selectedVendor: VendorGridItemDto;

  private selectedVendorId: number;
  
  constructor(
    injector: Injector,
    private readonly _vendorService: VendorService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadVendors();
    this.onChangeSelectedVendor();
  }

  async loadVendors(filter: AutoCompleteCompleteEvent = undefined): Promise<void> {
    try {
      this.showLoading();

      const inputDto: VendorPagedRequestDto = {
        name: filter?.query,
        maxResultCount: AppConsts.MaxPageSize,
        skipCount: 0
      };

      this.vendors = (await firstValueFrom(this._vendorService.getAllVendorsByInput(inputDto)))?.items || [];
      this.setVendorSelectedIfCorrespond();
    } finally {
      this.hideLoading();
    }
  }

  onChangeSelectedVendor(): void {
    this.changeSelectedVendor.emit(this.selectedVendor);
  }

  setSelectedVendorId(vendorId: number): void {
    this.selectedVendorId = vendorId;
    if (this.vendors && this.vendors.length > 0) {
      this.selectedVendor = this.vendors.find(vendor => vendor.id === vendorId);
    }
  }

  private setVendorSelectedIfCorrespond(): void {
    if (this.selectedVendorId) {
      this.selectedVendor = this.vendors.find(vendor => vendor.id === this.selectedVendorId);
    }
  }
}